/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserCrmIdSaveRequest} from '../models/UserCrmIdSaveRequest';

export interface UpdateUserCrmId$Request {
    userId: number;
    userCrmIdSaveRequest: UserCrmIdSaveRequest;
}

export interface UpdateUserCrmId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUserCrmIdRequest = createAction<PayloadData<void, UpdateUserCrmId$Request>>('UPDATE_USER_CRM_ID__UPDATE_USER_CRM_ID__REQUEST');
export const updateUserCrmIdSuccess = createAction<PayloadData<void, UpdateUserCrmId$Request>>('UPDATE_USER_CRM_ID__UPDATE_USER_CRM_ID__SUCCESS');
export const updateUserCrmIdFailure = createAction<PayloadData<Error, UpdateUserCrmId$Request, true>>('UPDATE_USER_CRM_ID__UPDATE_USER_CRM_ID__FAILURE');

export const updateUserCrmIdActions = [
    updateUserCrmIdRequest,
    updateUserCrmIdSuccess,
    updateUserCrmIdFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserCrmIdSaveRequest} meta.userCrmIdSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUserCrmId = (meta: UpdateUserCrmId$Request, config?: UpdateUserCrmId$Config) => {
    return {
        CALL_API: {
            types: updateUserCrmIdActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/integration-info/crm-id`,
            TRANSPORT_REQUEST_BODY: meta.userCrmIdSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

